import { useEffect, useState } from "react";
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { useInterval } from "../../../utils/useInterval";

const RoomBroadcast = ({sessionData, broadcastRef}) => {
	const [broadcast, setBroadcast] = useState([])

	useEffect(() => {
		if (broadcast.length !== 0) {
			confirmAlert({
				title: 'Broadcast',
				message: broadcast[broadcast.length-1]['pesan'],
				buttons: [
					{
					label: 'OK',
					onClick: () => null
					},
				]
				});
		}
	}, [broadcast.length])

	useInterval(async () => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/sesi-data/${sessionData.id}/`)
		.then(function (response) {
			setBroadcast(response.data.data.broadcast)
		})
		.catch((error) => {
			console.log(error)
		})
	}, 3000)

	return (
		<div className='discussion-room-card discussion-room-broadcast' ref={broadcastRef}>
				<p className='card-list-title'>This is the start of broadcast messages</p>
				<div>
					{
						broadcast.map((bc, index) => {
							let date = new Date(bc['waktu_pengiriman']); 
							let time = date.toLocaleString('en-GB').split(",")[1].split(":")
							time = `${time[0]}.${time[1]}`
							return (
								<div class="msg-other" key={index}>
									<p class="sender sender-other broadcast-sender">Host</p>
									<div class="talk-bubble">
										<div class="talktext">
											<p>{bc['pesan']}</p>
										</div>
										<div class="chat-time other">
											<p>{time}</p>
										</div>
									</div>
								</div>
						)})
					}
				</div>
		</div>
	);
}
 
export default RoomBroadcast;